<div class="external-redirect-message">
  Redirecting...
</div> 